import React from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import KivlikRoutes from "./KivlikRoutes";

function App() {
  return (
    <Router>
      <KivlikRoutes />
    </Router>
  );
}

export default App;
